require('masonry-layout');

export function initializeMasonry() {
    $('[data-masonry-layout="true"]').each(function () {
        let self = this;
        let $grid = $(self).masonry({
            percentPosition: true,
            horizontalOrder: true,
        })

        $grid.imagesLoaded().progress(function () {
            $grid.masonry('layout');
        });
    });
}
